import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataCustomerBOperator, DataCustomerLeadOperator } from '../creazione-nuovo-customer/creazione-nuovo-customer-costants';

@Component({
  selector: 'app-customer-leadoperator',
  templateUrl: './customer-leadoperator.component.html',
  styleUrls: ['./customer-leadoperator.component.css']
})
export class CustomerLeadoperatorComponent implements OnInit {

  @Input() customerDto: DataCustomerLeadOperator;

  @Input() isDisableFormLeadOperator: boolean;

  @Input() isModifica: boolean;

  @Output() changeCreationStepCustomerDataLeadOperatorItemEvent = new EventEmitter<string>();

  @Output() updateCustomerDataLeadOperatorItemEvent = new EventEmitter<DataCustomerLeadOperator>();

  listBOperator: DataCustomerBOperator[] = [];

  idGlobalCustomer: string = '';
  globalCustomerName: string = '';
  operator: string = '';
  note: string = '';
  ngOnDestroy: () => void;



  constructor() { }

  ngOnInit(): void {
    this.initializeFormCustomerLeadOperator();
  }

  initializeFormCustomerLeadOperator() {
    if (this.customerDto) {
      this.idGlobalCustomer = this.customerDto.leadOperatorGlobalCustomerId;
      this.globalCustomerName = this.customerDto.globalCustomerName;
      this.operator = this.customerDto.leadOperator;
      this.note= this.customerDto.note;
      this.listBOperator = this.customerDto.listBOperator;
    }

  }

  goToCustomerDataBOperator() {
    this.updateCustomerDataLeadOperator();
    this.changeCreationStepCustomerDataLeadOperatorItemEvent.emit("customer-data-bOperator");
  }

  updateCustomerDataLeadOperator() {
    this.customerDto.leadOperatorGlobalCustomerId = this.idGlobalCustomer;
    this.customerDto.globalCustomerName = this.globalCustomerName;
    this.customerDto.leadOperator = this.operator;
    this.customerDto.listBOperator = this.listBOperator;
    this.customerDto.note = this.note;
    this.updateCustomerDataLeadOperatorItemEvent.emit(this.customerDto);
  }

  customerDataLeadOperatorFormDisabled() {
    return (!this.idGlobalCustomer || !this.globalCustomerName || !this.operator);
  }

  resetForm() {
    if (!this.isModifica) {
      this.idGlobalCustomer = '';
    }

    this.globalCustomerName = '';
    this.operator = '';
    this.note='';
  }

  formDisable() {
    return this.isDisableFormLeadOperator;
  }


}
